export default "__VITE_ASSET__pR1bO0qU__"